import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import {connect} from "react-redux";
import {actions} from "../../actions";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { trackPromise} from 'react-promise-tracker';

import _ from 'lodash';

import NewAssessmentForm from './NewAssessmentForm';
import ArtifactPreview from './ArtifactPreview';
import ManageReviewers from '../users/ManageReviewers';
import AssessmentReview from './AssessmentReview';
import Rubrics from '../rubric/Rubrics';
import {BASENAME} from "../../constants";

import ValidationSnackBar from '../parts/ValidationSnackBar';
import {ROLES, withRoles} from "../Permissions";


const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    card: {
        minWidth: 275,
        marginBottom: 15
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    menu: {
        width: 200,

    },
    backButton: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    close: {
        padding: theme.spacing.unit / 2,
    },
    headertitle: {
        fontSize: 'x-large',
        color: '#000',
        backgroundColor: '#fff',
        padding: 16,
        marginBottom: -25
    }
});

function getSteps() {
    return ['Select Course and Outcome', 'Preview and Verify Artifact Data', 'Add Rubric', 'Add Reviewers', 'Review and Save'];
}

class NewAssessmentDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            form: {},
            changed: false,
            inCompleteFormSnackBarOpen: false,
            invalidReviewersSnackBarOpen: false,
            assessmentFailedToSavedSnackBarOpen: false,
            criteriaTitlesNotUniqueSnackBarOpen: false,
            missingReviewersSnackBarOpen: false,
            open: false
        };
        this.getStepContent = this.getStepContent.bind(this);
        this.handleReturnToAssessments = this.handleReturnToAssessments.bind(this);
    };

    handle

    getStepContent(stepIndex) {
        const {classes} = this.props;
        switch (stepIndex) {
            case 0:
                return (<div><NewAssessmentForm toggleLoadBar={this.props.toggleLoadBar}/></div>);
            case 1:
                return (<div><ArtifactPreview changed={this.state.changed}></ArtifactPreview></div>);
            case 2:
                return (
                    <div>
                        <Card className={classes.card}>
                            <Typography variant="h5" gutterBottom className={classes.headertitle}>
                                Rubric
                            </Typography>
                            <CardContent>
                                <Rubrics showImport={true} disabled={false}/>
                            </CardContent>
                        </Card>

                    </div>
                );
            case 3:
                return (<div><ManageReviewers/></div>);
            case 4:
                return (<div><AssessmentReview/></div>)
            default:
                return '';
        }
    }

    handleNext = () => {
        const {activeStep} = this.state;

        if (activeStep === 0) {
            if (!_.isEqual(this.state.form.numArtifactsPerTier, this.props.form.numArtifactsPerTier)||!_.isEqual(this.state.form.numArtifactsPerReviewer, this.props.form.numArtifactsPerReviewer)||!_.isEqual(this.state.form.numArtifacts, this.props.form.numArtifacts) || !_.isEqual(this.state.form.outcome, this.props.form.outcome) || !_.isEqual(this.state.form.courses, this.props.form.courses)|| !_.isEqual(this.state.form.checked, this.props.form.checked)) {
                this.setState({form: JSON.parse(JSON.stringify(this.props.form)), changed: true});
            } else {
                this.setState({changed: false});
            }
        }

        if (this.validation(activeStep)) {
            this.setState({
                activeStep: activeStep + 1,
            });
        }
    };

    validation(activeStep) {
        if (this.props.form) {
            if (!this.props.form.name || !this.props.form.outcome || !this.props.form.terms || !this.props.form.program || !this.props.form.courses || (this.props.form.courses && this.props.form.courses.length < 1)) {
                // alert('Incomplete form!');
                this.setState({inCompleteFormSnackBarOpen: true})
                return false;
            }
        }
        // unique rubrics criteria titles
        if (this.props.rubrics && activeStep === 2) {
            const titlesArr = this.props.rubrics.map(rubric => rubric.criteria_title);
            const titlesSet = new Set(titlesArr);
            if (titlesSet.size !== titlesArr.length) {
                this.setState({criteriaTitlesNotUniqueSnackBarOpen: true});
                return false;
            }
        }

        // missing reviewers
        if(this.props.reviewers && activeStep === 3) {
            if(this.props.reviewers.length === 0) {
                this.setState({missingReviewersSnackBarOpen: true});
                return false;
            }
        }

        return true;
    }

    handleBack = () => {
        const {activeStep} = this.state;
        this.setState({
            activeStep: activeStep - 1,
        });
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({
            inCompleteFormSnackBarOpen: false,
            invalidReviewersSnackBarOpen: false,
            assessmentFailedToSavedSnackBarOpen: false,
            criteriaTitlesNotUniqueSnackBarOpen: false,
            missingReviewersSnackBarOpen: false,
            open: false
        });
    };

    // createArtifactScore() {
    //     // let artifactScore = [];
    //     let scores = Array.apply(null, Array(this.props.rubrics.length)).map(function () {
    //         return null
    //     })
    //     let artifactScore = _.map(this.props.artifacts, artifact => {
    //         return {
    //             artifact_id: artifact.canvas_submission_id,
    //             rubricScores: scores
    //         }
    //     });
    //
    //     return _.map(this.props.reviewers, reviewer => {
    //         //reviewer.artifactScores = artifactScore;
    //         const shuffled = artifactScore.sort(() => 0.5 - Math.random());
    //         let selected = shuffled.slice(0, this.props.form.numArtifactsPerReviewer);
    //         reviewer.artifactScores = selected;
    //
    //     })
    // }

    handleSave = () => {
        if (this.props.reviewers.length < 2) {
            // alert('There must be at least two reviewer');
            this.setState({invalidReviewersSnackBarOpen: true});
        } else {
            // this.createArtifactScore();
            let assessmentObj = {
                reviewers: this.props.reviewers,
                name: this.props.form.name,
                department: this.props.form.department,
                program: this.props.form.program,
                college: this.props.form.college,
                numArtifacts: this.props.form.numArtifacts,
                numArtifactsPerReviewer: this.props.form.numArtifactsPerReviewer,
                terms: this.props.form.terms,
                outcome: this.props.form.outcome,
                courses: this.props.form.courses,
                artifacts: this.props.artifacts,
                rubrics: this.props.rubrics,
                coordinator_unid: this.props.user.unid,
                coordinator_name: this.props.user.display_name,
                isTiered:this.props.form.checked
            }

            try {
                const res = trackPromise(fetch(BASENAME + '/api/add_assessment', {
                    method: "post",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(assessmentObj)
                }).then((res) => {
                    if (res.status == 200) {
                        this.setState({open: true});


                    } else {
                        this.setState({assessmentFailedToSavedSnackBarOpen: true});
                    }
                }))
            } catch (err) {
                this.setState({assessmentFailedToSavedSnackBarOpen: true});
            }

        }
    };

    handleReturnToAssessments() {
        this.props.history.push('/assessments');
    }

    renderSnackBars() {
        return (<div>
            <ValidationSnackBar variant="error" message={"Incomplete Form"} open={this.state.inCompleteFormSnackBarOpen} onClose={this.handleClose}/>
            <ValidationSnackBar variant="error" message={"Assessment must have at least two reviewers"} open={this.state.invalidReviewersSnackBarOpen} onClose={this.handleClose}/>
            <ValidationSnackBar variant="error" message={"Failed to save"} open={this.state.assessmentFailedToSavedSnackBarOpen} onClose={this.handleClose}/>
            <ValidationSnackBar variant="error" message={"Criteria titles are not unique"} open={this.state.criteriaTitlesNotUniqueSnackBarOpen} onClose={this.handleClose}/>
            <ValidationSnackBar variant="error" message={"Missing reviewers"} open={this.state.missingReviewersSnackBarOpen} onClose={this.handleClose}/>
            <Dialog
                open={this.state.open}
                onClose={this.handleReturnToAssessments}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Assessment Saved Successfully"}</DialogTitle>
                <DialogActions>
                    <Button onClick={this.handleReturnToAssessments} color="secondary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>


        </div>)
    }

    render() {
        const {classes} = this.props;
        const steps = getSteps();
        const {activeStep} = this.state;

        return (

            <div className={classes.root}>
                <div style={{display: 'flex'}}>
                    <Stepper activeStep={activeStep} alternativeLabel className='stepper'
                             style={{flex: '85%', backgroundColor: '#F5F5F5', width: '100%', position: 'sticky', top: '0'} }>
                        {steps.map(label => {
                            return (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>

                    <div style={{flex: '15%', paddingTop: '20px', position: 'sticky', top: '0', display: 'flex'}}>
                        {this.state.activeStep === steps.length - 1 ? (
                            <div>
                                <Button disabled={activeStep === 0} onClick={this.handleBack}
                                        className={classes.backButton} color='secondary'>
                                    Back
                                </Button>
                                <Button variant="contained" color="secondary" onClick={this.handleSave}>Save</Button>
                            </div>
                        ) : (
                            <div>
                                <Button disabled={activeStep === 0} color='secondary' onClick={this.handleBack}
                                        className={classes.backButton}>
                                    Back
                                </Button>
                                <Button variant="contained" color="secondary" onClick={this.handleNext}>
                                    Next
                                </Button>

                            </div>
                        )}

                    </div>
                </div>
                <div>
                    <div>
                        <div className={classes.instructions}>{this.getStepContent(activeStep, classes)}</div>

                    </div>
                </div>
                {this.renderSnackBars()}
            </div>

        )
    }
}

function mapStateToProps(state) {
    return {
        form: state.newAssessmentForm,
        reviewers: state.reviewers,
        artifacts: state.artifacts,
        rubrics: state.rubrics,
        user: state.user
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRoles([ROLES.COORDINATOR,ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN])(NewAssessmentDashboard)));

